export default __webpack_public_path__ + "static/media/video-call-ringtone.c6a4b5ef.mp3";